import { render, staticRenderFns } from "./SupportTicketDialogFollowers.vue?vue&type=template&id=8cd09f28"
import script from "./SupportTicketDialogFollowers.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialogFollowers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports